import { render, staticRenderFns } from "./AddAuthorizedUser.vue?vue&type=template&id=150cfe6d&scoped=true"
import script from "./AddAuthorizedUser.vue?vue&type=script&lang=js"
export * from "./AddAuthorizedUser.vue?vue&type=script&lang=js"
import style0 from "./AddAuthorizedUser.vue?vue&type=style&index=0&id=150cfe6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150cfe6d",
  null
  
)

export default component.exports